import * as app from "./app";

const API = {
  ...app
};
export default API;
